module.exports = __webpack_public_path__ + "img/3.54f5d28e.jpg";